// extracted by mini-css-extract-plugin
module.exports = {"bottom-player-desktop":"_378D7","bottom-player-mobile":"_7R8fs"};